import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, forwardRef, useEffect } from "react";
import { Controller, useController, } from "react-hook-form";
import { Box, InputAdornment, Skeleton, IconButton, FormControl, useMediaQuery, useTheme, } from "@mui/material";
import { Eye, EyeSlash } from "iconsax-react";
import { ErrorWithIcon } from "./ValidationMessage";
import { StyledTextField } from "./StyledTextField";
export const HInput = forwardRef(({ label, name, control, leftIcon, rightIcon, multiLines, rows, backgroundColor, placeholder, type = "text", rules, disabled = false, error, defaultValue, loading = false, style, hiddenLabel = false, onBlur, textInputStyles, }, ref) => {
    const [showPassword, setShowPassword] = useState(true);
    const [focused, setFocused] = useState(false);
    const [shrink, setShrink] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery("(max-width: 800px)");
    const { field } = useController({ control, name });
    const handleTogglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    useEffect(() => {
        setShrink(defaultValue || error || focused || field.value);
    }, [defaultValue, error, focused, field.value]);
    const handleBlur = (e) => {
        setFocused(false);
        if (onBlur) {
            onBlur(e);
        }
        // Trim the value and update the field
        const trimmedValue = e.target.value.trim();
        field.onChange(trimmedValue);
    };
    return (_jsx(Box, { width: "100%", style: style, className: "h-input-container", children: loading ? (_jsx(Skeleton, { animation: "wave", height: "55px" })) : (_jsx(Controller, { name: name, control: control, rules: rules, defaultValue: defaultValue, render: ({ field }) => (_jsxs(FormControl, { fullWidth: true, variant: "filled", children: [_jsx(StyledTextField, { ...field, inputRef: ref, type: type === "password"
                            ? showPassword
                                ? "text"
                                : "password"
                            : type, hiddenLabel: hiddenLabel, label: label ? label : "", sx: {
                            ...textInputStyles,
                            input: {
                                background: label
                                    ? backgroundColor
                                        ? backgroundColor
                                        : "transparent"
                                    : "white",
                                "&::-ms-reveal": {
                                    display: "none",
                                },
                            },
                        }, multiline: multiLines, rows: rows, background: backgroundColor, placeholder: placeholder, disabled: disabled, error: !!error, fullWidth: true, variant: "filled", style: style, onFocus: () => setFocused(true), onBlur: handleBlur, slotProps: {
                            input: {
                                startAdornment: leftIcon && (_jsx(InputAdornment, { position: "start", children: leftIcon })),
                                endAdornment: type === "password" ? (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { onClick: handleTogglePasswordVisibility, edge: "end", children: showPassword ? _jsx(EyeSlash, {}) : _jsx(Eye, {}) }) })) : (rightIcon && (_jsx(InputAdornment, { position: "end", children: rightIcon }))),
                            },
                            inputLabel: shrink ? { shrink: true } : {},
                        } }), _jsx(ErrorWithIcon, { error: error })] })) })) }));
});
